import React, { useState, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import settings from '../config/settings';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = settings.navLinks;

  return (
    <header className="fixed top-0 left-0 w-full z-[100] bg-transparent">
      <div className={`w-full px-4 sm:px-6 lg:px-8 transition-all duration-300 ${
        isScrolled ? 'py-2' : 'py-4'
      }`}>
        <div className="bg-white/80 backdrop-blur-md rounded-3xl shadow-sm border border-white/20 px-6 py-2">
          <div className="flex items-center justify-between">
            {/* Left: Logo */}
            <Link to="/" className="flex-shrink-0 group">
              <img 
                src={settings.logo} 
                alt={`${settings.siteName} Logo`} 
                className="h-12 w-auto transition-opacity group-hover:opacity-80"
              />
            </Link>

            {/* Center: Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-8">
              {navLinks.map((link, index) => (
                <NavLink
                  key={link.name}
                  to={link.path}
                  className={({ isActive }) => 
                    `font-medium py-2 transition-colors ${
                      isActive ? 'text-emerald-600' : 'text-gray-700 hover:text-emerald-600'
                    }`
                  }
                >
                  {link.name}
                </NavLink>
              ))}
            </nav>

            {/* Right: CTA Buttons */}
            <div className="hidden lg:flex items-center space-x-4">
              <button className="bg-emerald-600 text-white px-6 py-2.5 rounded-full font-medium hover:bg-emerald-700 transition-all duration-200 shadow-sm">
                Apply Now
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="lg:hidden p-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
            >
              <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="w-6 h-6" />
            </button>
          </div>

          {/* Mobile Menu */}
          {isMenuOpen && (
            <div className="lg:hidden mt-4 pt-4 border-t border-gray-200">
              <nav className="flex flex-col space-y-2">
                {navLinks.map((link, index) => (
                  <NavLink
                    key={link.name}
                    to={link.path}
                    className={({ isActive }) => 
                      `block px-4 py-3 rounded-lg font-medium ${
                        isActive ? 'bg-emerald-50 text-emerald-600' : 'text-gray-700 hover:bg-gray-50'
                      }`
                    }
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {link.name}
                  </NavLink>
                ))}
                <div className="flex flex-col space-y-3 px-4 pt-4">
                  <button className="bg-emerald-600 text-white py-3 rounded-full font-medium hover:bg-emerald-700 transition-colors">
                    Apply Now
                  </button>
                </div>
              </nav>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;